import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

export function StateReportSubmitScreen() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/reports/resident-state-reporting`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.RESIDENT_STATE_REPORTING}
      backPath={backPath}
    />
  );
}
